import React from 'react';
import JoyAvatar from "@/components/common-components/joy-avatar/joy-avatar.tsx";
import HeadingComponent from "@/components/common-components/heading/HeadingComponent.tsx";

interface RequirementGatheringWelcomeProps {
    greeting: string;
    userName: string;
}

const RequirementGatheringWelcomeComponent: React.FC<RequirementGatheringWelcomeProps> = ({
    greeting,
    userName
}) => {

    return (
        <>
            <div className='flex justify-center'>
            <JoyAvatar size={"large"} className={'mb-5'} />
            </div>
            <HeadingComponent showDummyGap={false}>
                {greeting}<span className="text-primary mb-2"> {userName}!</span>
                <br />
                {/* {isMobile ? ( */}
                    <>
                        <span className="text-lg font-normal mb-4 block mt-4">
                            I'm <span className="text-primary font-semibold">Zoya</span>, your AI Project Manager.
                        </span>
                        <span className="text-base font-normal text-gray-400 block">
                        I’ll help shape your project ideas into clear, actionable plans. What project do you want to create?      
                                          </span>
                        
                    </>
                {/* ) : (
                    // Full desktop version
                    <>
                        <span className="text-xl font-normal mb-4 block mt-4">
                            I'm <span className="text-primary font-semibold ">Zoya</span>, your AI Project Manager Agent.
                            I specialize in helping you create a comprehensive project scope and turning your ideas into actionable development plans.
                        </span>
                        <span className="text-lg font-normal text-gray-400 block mb-4">
                            Through our interactive conversation, I'll help you define:
                        </span>
                        <div className="text-base text-gray-300 space-y-2 ml-4">
                            <div className="flex items-center gap-2">
                                <span className="w-2 h-2 bg-primary rounded-full"></span>
                                <span>Project objectives and goals</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-2 h-2 bg-primary rounded-full"></span>
                                <span>Feature requirements and specifications</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-2 h-2 bg-primary rounded-full"></span>
                                <span>User experience and interface design</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-2 h-2 bg-primary rounded-full"></span>
                                <span>Technical architecture and implementation plan</span>
                            </div>
                        </div>
                       
                    </>
                )} */}
            </HeadingComponent>
        </>
    );
};

export default RequirementGatheringWelcomeComponent;
